import { gtmEnabled } from "@/lib/analytics/gtm-utils"
import { env } from "@/lib/env"

export function GtmNoScript({
  supportedBrowser = true,
}: {
  supportedBrowser?: boolean
}) {
  if (!supportedBrowser) {
    return null
  }

  const gtmAccounts = env("NEXT_PUBLIC_GTM_ACCOUNTS")?.split(",") || []
  return (
    <>
      {gtmEnabled() && (
        <>
          {gtmAccounts.map((gtmId, idx) => (
            <div key={idx}>
              {/* Google Tag Manager (noscript) */}
              <noscript>
                <iframe
                  src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
                  height="0"
                  width="0"
                  style={{ display: "none", visibility: "hidden" }}
                ></iframe>
              </noscript>
            </div>
          ))}
        </>
      )}
    </>
  )
}
